'use strict';

var utils = function () {
	var _getObjectSize = function _getObjectSize(obj) {
		var n = 0;
		for (var _prop in obj) {
			if (obj.hasOwnProperty(_prop)) n++;
		}
		return n;
	};

	var _getObjectByProp = function _getObjectByProp(array, prop, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][prop] === value.toString()) return array[i];
		}
		return null;
	};

	var _mountPagination = function _mountPagination($pagContainer, totalPag, $pagItem, $pagNext, $pagPrev) {
		$pagContainer.slick({
			autoplay: false,
			arrows: false,
			speed: 300,
			dots: false,
			infinite: false
		});

		_paginatAddEvents($pagContainer, totalPag, $pagItem, $pagNext, $pagPrev);
	};

	var _paginatAddEvents = function _paginatAddEvents($pagContainer, totalPag, $pagItem, $pagNext, $pagPrev) {
		$('.js-paginat-item').removeClass('activo');
		$('.js-paginat-item[data-slide=0]').addClass('activo');

		$pagItem.on('click', function () {
			$pagContainer.slick('slickGoTo', $(this).data('slide'));
			$pagItem.removeClass('activo');
			$(this).addClass('activo');
		});

		$pagNext.on('click', function () {
			$pagContainer.slick('slickNext');
		});

		$pagPrev.on('click', function () {
			$pagContainer.slick('slickPrev');
			if ($pagContainer.slick('slickCurrentSlide') === 0) {
				$(this).addClass('inactivo');
			} else {
				$(this).removeClass('inactivo');
			}
		});

		$pagContainer.on('afterChange', function (slick, currentSlide) {
			var currentS = $pagContainer.slick('slickCurrentSlide');
			$pagItem.removeClass('activo');
			$('.js-paginat-item[data-slide=' + currentS + ']').addClass('activo');

			$('.js-paginat-arrow').removeClass('inactivo');
			if (currentS === 0) {
				$pagPrev.addClass('inactivo');
			}
			if (currentS === totalPag) {
				$pagNext.addClass('inactivo');
			}
		});
	};

	var _paginatRemoveEvents = function _paginatRemoveEvents($pagItem, $pagNext, $pagPrev, $pagBlock) {
		$pagItem.off('click');
		$pagNext.off('click');
		$pagPrev.off('click');
		$pagBlock.addClass('hidden');
	};

	var _initPagination = function _initPagination(totalPag) {

		var $pagContainer = $('.js-mdo-pag-container');
		var $pagItem = $('.js-paginat-item');
		var $pagNext = $('.js-paginat-next');
		var $pagPrev = $('.js-paginat-prev');
		var $pagBlock = $('.js-pagination');

		var paginationOn = void 0;

		$(window).on('load', function () {
			if ($(window).width() <= 600) {
				paginationOn = false;
			} else {
				_mountPagination($pagContainer, totalPag, $pagItem, $pagNext, $pagPrev);
				paginationOn = true;
			}
		});

		$(window).on('resize', function () {
			if ($(window).width() <= 600) {
				if (paginationOn) {
					$pagContainer.slick('destroy');
					_paginatRemoveEvents($pagItem, $pagNext, $pagPrev, $pagBlock);
					paginationOn = false;
				} else {
					$pagBlock.addClass('hidden');
				}
			} else {
				if (!paginationOn) {
					$pagBlock.removeClass('hidden');
					_mountPagination($pagContainer, totalPag, $pagItem, $pagNext, $pagPrev);
					paginationOn = true;
				}
			}
		});
	};

	var _setLangMessages = function _setLangMessages(obj) {
		var langMessages = {};
		for (prop in obj) {
			langMessages[prop] = obj[prop];
		}
		sessionStorage.langMessages = JSON.stringify(langMessages);
	};

	var _getLangMessages = function _getLangMessages() {
		return JSON.parse(sessionStorage.langMessages);
	};

	return {
		getObjectSize: _getObjectSize,
		getObjectByProp: _getObjectByProp,
		initPagination: _initPagination,
		setLangMessages: _setLangMessages,
		getLangMessages: _getLangMessages
	};
}();